import { Radio } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { doc_insertContentAfter_Api, doc_insertContentBefore_Api } from 'apis'
import ApiInfoForm from 'components/form/ApiInfoForm'
import FieldDecorator from 'components/form/FieldDecorator'
import { SubmitButton } from 'components/form/FormActionBar'
import { createValue } from 'components/form/utils'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, { useMemo, useState } from 'react'
import { SelectWidget } from 'views/AppLocals/custom/ReactSelectComponents'
import { bindQueryParam } from 'views/AppLocals/functions/routerHelper'
import { deepTranslate } from 'views/Shared'
import { DocumentRowTypes } from '../components/DocumentDetail'

const RaragraphActionTypes = Object.freeze({
  BEFORE: {
    label: 'before',
    value: 'before',
    params: {
      apiInfo: doc_insertContentBefore_Api,
      createQuery: ({ id }) => bindQueryParam({ id }),
    },
  },
  AFTER: {
    label: 'after',
    value: 'after',
    params: {
      apiInfo: doc_insertContentAfter_Api,
      createQuery: ({ id }) => bindQueryParam({ id }),
    },
  },
})

export const ParagraphInsertForm = ({
  document_id,
  paragraph_id,
  paragraph_value,
  paragraph_type,
  onClose,
  renderPreview = (widget, paragraph_value) => widget,
}) => {
  const t = useTranslate()

  const [action, setAction] = useState(RaragraphActionTypes.BEFORE.value)

  const params = useMemo(() => {
    const found = _.find(Object.values(RaragraphActionTypes), { value: action })
    return found?.params ?? {}
  }, [action])

  const query = useMemo(() => {
    const { createQuery } = params ?? {}
    if (_.isFunction(createQuery)) {
      return createQuery({ id: document_id })
    }
    return undefined
  }, [params, document_id])

  return (
    <ApiInfoForm
      onSuccess={() => {
        onClose()
      }}
      initialValues={{
        paragraph_id,
        paragraph_type,
        paragraph_value,
      }}
      query={query}
      apiInfo={params?.apiInfo}>
      {({ handleChange }) => (
        <div className="flex flex-col space-y-3">
          {/*<FieldDecorator label="preview">*/}
          {/*  {renderPreview(*/}
          {/*    <div className="italic p-3 border rounded-lg">*/}
          {/*      {paragraph_value}*/}
          {/*    </div>,*/}
          {/*    paragraph_value*/}
          {/*  )}*/}
          {/*</FieldDecorator>*/}
          <FieldDecorator label="position">
            <Radio.Group
              value={action}
              onChange={(event) => {
                setAction(event.target.value)
              }}
              options={[
                RaragraphActionTypes.BEFORE,
                RaragraphActionTypes.AFTER,
              ].map(deepTranslate(t))}
            />
          </FieldDecorator>
          <FieldDecorator label="clause type">
            <SelectWidget
              className="w-full"
              defaultValue={paragraph_type}
              onChange={(value) => {
                handleChange(createValue('paragraph_type', value))
              }}
              placeholder={t('clause type')}
              options={Object.values(DocumentRowTypes).map(deepTranslate(t))}
            />
          </FieldDecorator>
          <FieldDecorator label="content">
            <TextArea
              rows={5}
              name="paragraph_value"
              placeholder={t('content')}
              onChange={(event) => {
                handleChange(createValue('paragraph_value', event.target.value))
              }}
            />
          </FieldDecorator>

          <div className="text-right py-3">
            <SubmitButton />
          </div>
        </div>
      )}
    </ApiInfoForm>
  )
}

export default ParagraphInsertForm
